var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var TrustpilotFallbackStyles = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .fallback-wrapper {\n    ", ";\n  }\n  height: auto;\n  svg {\n    .st0 {\n      fill: #191919;\n    }\n    .st1 {\n      fill: #00b67a;\n    }\n    .st2 {\n      fill: #005128;\n    }\n"], ["\n  .fallback-wrapper {\n    ", ";\n  }\n  height: auto;\n  svg {\n    .st0 {\n      fill: #191919;\n    }\n    .st1 {\n      fill: #00b67a;\n    }\n    .st2 {\n      fill: #005128;\n    }\n"])), function (_a) {
    var width = _a.width;
    return "width: ".concat(width ? "".concat(width, "px") : '128px');
});
var templateObject_1;
